import { useTranslation } from "react-i18next";
import { Sidebar } from "flowbite-react";
import MainLogo from "../assets/main_logo.svg";
import type { CustomFlowbiteTheme } from "flowbite-react";
import { Accordion } from "flowbite-react";
import { useState } from "react";
import ShLoader from "./ShLoader";
import { useNavigate, useRouter } from "@tanstack/react-router";
import { Routes } from "../utils/costants/routes";
import { useTheme } from "../providers/ThemeProvider";
import DynamicLogo from "./DynamicLogo";

const customTheme: CustomFlowbiteTheme["sidebar"] = {
  root: {
    inner: "px-0 rounded-none ",
  },
  collapse: {
    icon: {
      base: "stroke-secondaryColor-200",
      open: {
        on: "stroke-secondaryColor-200",
      },
    },
  },
  item: {
    icon: {
      base: "stroke-secondaryColor-200  bg-danger-200 ",
      active: "stroke-shblue-500",
    },

    listItem:
      "rounded-none [&>a]:hover:rounded-none hover:bg-secondaryColor-100 [&>a]:px-4 [&>a>span]:px-0 [&>a>span>i]:mr-2   [&>a>span>i]:text-xl  ",
    active: "text-shblue-500 bg-shblue-50 w-full rounded-none font-bold  ",
    collapsed: {
      insideCollapse:
        " rounded-none flex flex-row justify-start [&>span]:max-w-[180px] bg-danger-200 border-box  [&>span]:text-wrap",
    },
  },
};

interface ShSidebarProps {
  isSideNavOpen: boolean;
  onBackdropClick: () => void;
  navBarItems: any;
  isLoading: boolean;
  currentRoot: string;
}
export default function ShSidebar({
  isSideNavOpen,
  onBackdropClick,
  navBarItems,
  isLoading,
  currentRoot,
}: ShSidebarProps) {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("2");
  const navigate = useNavigate();
  const router = useRouter();

  // Hook per la configurazione dinamica
  const { logo, brandLabel, isConfigured } = useTheme();

  return (
    <>
      {/*  <!-- Side Navigation --> */}
      <aside
        id="nav-menu-1"
        aria-label="Side navigation"
        className={`xs:absolute lg:relative top-0 bottom-0 left-0 z-40 flex min-w-[240px] max-w-[240px] w-[240px]   sm:shadow-[0_4px_20px_0_rgba(0,0,0,0.25)] 
        lg:shadow-none flex-col  bg-white transition-transform lg:translate-x-[0px] ${isSideNavOpen ? "translate-x-[0px]" : " translate-x-[-240px]"
          }`}
      >
        <Sidebar
          theme={customTheme}
          id="nav-menu-1"
          aria-label="Side navigation"
          className={`xs:absolute lg:relative top-0 left-0 z-40  border-solid border-r border-r-secondaryColor-200 flex w-full min-w-[240px] max-w-[240px] h-screen  px-0 mx-0 lg:w-[240px] overflow-y-auto overflow-x-hidden hide-scrollbar
          flex-col  bg-white transition-transform  `}
        >
          <div
            aria-label={brandLabel || t("main_logo")}
            className="flex items-center justify-center w-full pt-6 pb-6"
          >
            <DynamicLogo
              maxWidth="100px"
              maxHeight="40px"
              className="self-center"
              alt={brandLabel || t("main_logo")}
              onClick={() => navigate({ to: Routes.CLIENTS_LIST })}
            />
          </div>
          {isLoading ? (
            <div
              className={`flex items-center justify-center w-full transition-all duration-500 loader ${true ? "opacity-100" : "opacity-0 pointer-events-none"} transition-opacity duration-300`}
              style={{ height: "calc(100vh - 130px)" }}
            >
              <ShLoader />
            </div>
          ) : (
            <Sidebar.Items>
              <Sidebar.ItemGroup>
                {navBarItems.map((e: any, indx: number) =>
                  window.location.href.includes("beelocal") &&
                    e[Object.keys(e)[0]]["item_label"]
                      ?.toLowerCase()
                      .includes("adv")
                    ? null
                    : e[Object.keys(e)[1]].length > 0
                      ? e[Object.keys(e)[0]]["enabled"] === "1" && (
                        <Accordion
                          collapseAll
                          className="p-0 m-0 bg-white border-white divide-x-0 divide-white cursor-pointer ring-0 ring-white focus:ring-0 focus:border-white hover:rounded-none"
                        >
                          <Accordion.Panel className="bg-white border-white ring-0 ring-white focus:ring-0 focus-border-white hover:rounded-none">
                            <Accordion.Title className="h-12 px-4 m-0 font-normal bg-white border-0 border-white divide-x-0 divide-white ring-0 ring-white focus:ring-0 focus:border-white text-dark-500 hover:rounded-none">
                              <i
                                className={`ml-0 mr-4  ${e[Object.keys(e)[0]]["left_icon"]}  ${selectedTab === e[Object.keys(e)[0]]["id_menu"] ? "text-shblue-500" : "text-secondaryColor-500"}`}
                              ></i>{" "}
                              {e[Object.keys(e)[0]]["item_label"]}
                            </Accordion.Title>
                            <Accordion.Content className="p-0 m-0 bg-white border-white divide-x-0 divide-white focus:border-white">
                              {e[Object.keys(e)[1]].map(
                                (e: any, indx: number) => (
                                  <Sidebar.Item
                                    active={
                                      selectedTab ===
                                      e[Object.keys(e)[0]]["id_menu"]
                                    }
                                    key={indx}
                                    onClick={() => {
                                      setSelectedTab(
                                        e[Object.keys(e)[0]]["id_menu"]
                                      );
                                      navigate({
                                        to: `/${e[Object.keys(e)[0]]["root"]}`,
                                      });
                                    }}
                                    className={`group-hover:bg-white [&>span]:max-w-[180px] [&>span]:ml-9 border-box  [&>span]:text-wrap cursor-pointer  ${selectedTab === e[Object.keys(e)[0]]["id_menu"] ? "text-shblue-500" : "text-secondaryColor-800"}`}
                                  >
                                    {e[Object.keys(e)[0]]["item_label"]}
                                  </Sidebar.Item>
                                )
                              )}
                            </Accordion.Content>
                          </Accordion.Panel>
                        </Accordion>
                      )
                      : e[Object.keys(e)[0]]["enabled"] === "1" && (
                        <Sidebar.Item
                          key={indx}
                          active={
                            router.latestLocation.pathname === `/${e[Object.keys(e)[0]]["root"]}`
                            ||
                            ((
                              router.latestLocation.pathname === "/client_profile") &&
                              indx === 1)
                          }
                          className={`cursor-pointer ${router.latestLocation.pathname === `/${e[Object.keys(e)[0]]["root"]}`
                              ||
                              ((
                                router.latestLocation.pathname === "/client_profile") &&
                                indx === 1)
                              ? "text-shblue-500"
                              : "text-secondaryColor-800"
                            }`}
                          onClick={() => {
                            setSelectedTab(e[Object.keys(e)[0]]["id_menu"]);
                            navigate({
                              to: `/${e[Object.keys(e)[0]]["root"]}`,
                            });
                          }}
                        >
                          <i
                            className={`${e[Object.keys(e)[0]]["left_icon"]} ${router.latestLocation.pathname === `/${e[Object.keys(e)[0]]["root"]}` ||
                                ((router.latestLocation.pathname === "" ||
                                  router.latestLocation.pathname === "/client_profile") &&
                                  indx === 1)
                                ? "text-shblue-500"
                                : "text-secondaryColor-500"
                              }`}
                          ></i>{" "}
                          {e[Object.keys(e)[0]]["item_label"]}
                        </Sidebar.Item>
                      )
                )}
              </Sidebar.ItemGroup>
            </Sidebar.Items>
          )}
        </Sidebar>
      </aside>
      {/*  <!-- Backdrop --> */}
      <div
        className={`fixed top-0 bottom-0 left-0 right-0 z-30 bg-slate-900/20 transition-colors lg:hidden ${isSideNavOpen ? "block" : "hidden"
          }`}
        onClick={onBackdropClick}
      ></div>
    </>
  );
}

// <div className="box-border flex flex-row items-start justify-start w-full group hover:bg-secondaryColor-50">
//   <i className="pl-4 mt-2 ri-admin-line"></i>
//   <Sidebar.Collapses
//     key={indx}
//     label={e[Object.keys(e)[0]]["item_label"]}
//     className="rounded-none [&>span]:w-[150px] w-full text-wrap"
//   >

//     {/* <Sidebar.Collapse
//     label={"coa"}
//     className="rounded-none [&>svg]:w-[20px] px-4"
//   >
//     <Sidebar.Item href="#">"oooo"</Sidebar.Item>
//   </Sidebar.Collapse> */}
//   </Sidebar.Collapse>
// </div>
